<template>
  <div class="aside">
    <div class="aside-menus">
      <div v-for="(item, i) in menus" :key="i" :class="['menu-item', { 'active-menu': $route.path.includes(item.path) }]"
        @click="toPage(item.path)">
        <img :src="require('@/assets/images/icon/' + item.icon + ($route.path.includes(item.path) ? '-on.png' : '.png'))" alt="" width="16"
          height="16">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  components: {
  },
  props: {
    menus: {

    },
    menu: {
      type: String,
    },
  },
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {
    toPage(path, query) {
      this.$router.push({ path, query });
    },
  },
};
</script>
<style lang="scss" scoped>
.aside {
  flex: 1;
  max-width: 160px;
  background: #FFFFFF;
  .aside-menus .menu-item:last-child{
    border: none;
  }
  .menu-item {
    font-weight: 400;
    font-size: 16px;
    color: #1A1A1A;
    margin: 0 30px;
    border-bottom: 1px solid #EEEEEE;
    padding: 20px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img{
      margin-right: 5px;
    }
  }
  .active-menu{
    color: #D81D10;
  }
}
</style>
